//objenin her bir elemanı pageType
//obje içindeki elemanlar ise sayfalardır.
//sayfaların sahip olduğu boolean değer ise sayfayı temsil eden asıl izindir. Eğer bu izin yoksa sayfa router'de render edilmez.
const routePermissions: any = {
  company: {
    company: true,
    announce: false,
    member: false,
  },
  member: {
    member: true,
    company: false,
  },
  mail_t: {
    mail_t: true,
  },
  article: {
    article: true,
  },
  announce: {
    announce: true,
    member: false,
  },
  attribute: {
    attribute: true,
  },
  customer: {
    customer: true,
    user: false,
    activity: false,
  },
  survey: {
    survey: true,
  },
  admin: {
    admin: true,
    roles: false,
  },
  role: {
    role: true,
  },

  settings: {
    settings: true,
    comp_settings: false,
  },
  page: {
    page: true,
  },
  nav: {
    nav: true,
  },
  contact_form: {
    contact_form: true,
  },
  event: {
    event: true,
  },
  blog: {
    blog: true,
  },
};

export default routePermissions;
